// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lbvhywxvthwgiebjsrlr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxidmh5d3h2dGh3Z2llYmpzcmxyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM3MzE4MjYsImV4cCI6MjA1OTMwNzgyNn0.SriuXDKuf0URQfJbAqQO-4r8Ghg0KVOWV6Lq99u86hU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});